import {$http, Constants} from '@/store/actions/constants';

const url = `${Constants.BaseURL}/timeline`;

export const TimelineActions = {
  Get: ({commit, state}, id) => {
    return $http.get(`${url}/${id}`, state.authHeader);
  },
  Put: ({commit, state}, payload) => {
    return $http.put(`${url}/${payload.id}`, payload.data, state.authHeader);
  },
  Delete: ({commit, state}, id) => {
    return $http.delete(`${url}/${id}`, state.authHeader);
  },
};
